"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appProcessLauncher_1 = require("../appProcessLauncher");
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const functionIsAppProcessFunction_1 = __importDefault(require("../../typeAssertions/functionIsAppProcessFunction"));
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const appProcessBuilder = ({ getApiBaseInputs, setApiBaseInputs, functionDefinitions, overwriteExecuteOnCloud, reportCloudFunctionCall, }) => async ({ functionId, entryVars, callbacks, processor, lastFunctionsOutputs, itemContext, controlCallerId, eventOutputs, executeProcesses, }) => {
    const buildOrders = processor.root.getBuildOrders();
    if ((0, valueIsNullOrUndef_1.default)(buildOrders)) {
        throw new Error('A build orders is required to run app processes');
    }
    const { functions, appProcesses } = buildOrders;
    if ((0, valueIsNullOrUndef_1.default)(functions)) {
        throw new Error('Execute an app process requires functions to be declared');
    }
    const appProcessFunction = functions[functionId];
    if ((0, valueIsNullOrUndef_1.default)(appProcessFunction)) {
        throw new Error('No process function found');
    }
    if (!(0, functionIsAppProcessFunction_1.default)(appProcessFunction)) {
        throw new Error('The app process function should be of type appProcess');
    }
    const { appProcessDetails: { id: appProcessId } } = appProcessFunction;
    if ((0, valueIsNullOrUndef_1.default)(appProcesses)) {
        throw new Error('To execute an app process, buildOrders require appProcesses object');
    }
    const appProcessDefinition = appProcesses[appProcessId];
    if ((0, valueIsNullOrUndef_1.default)(appProcessDefinition)) {
        throw new Error(`No app process found with id ${appProcessId}`);
    }
    const CALLER_NAME = 'appProcess';
    const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)(CALLER_NAME, processor);
    const appId = (0, getEnsuredAppIdFromProcessor_1.default)(CALLER_NAME, processor);
    if (processor.root.isInDevelopment) {
        const isOrWillRunOnCloud = appProcessDefinition.runingOnCloud;
        if (isOrWillRunOnCloud) {
            const hasPermissionToRun = await reportCloudFunctionCall({
                appId,
                appProcessId,
            });
            if (hasPermissionToRun === false) {
                processor.root.alert('Quota exceded', 'You cannot run more appProcess');
                return;
            }
        }
    }
    if (appProcessDefinition.runingOnCloud) {
        const { currentUser } = processor.root.firebase.auth();
        getApiBaseInputs(appId)
            .then(async (apiBaseInputs) => {
            const rawParams = {
                projectId,
                appId,
                functionId,
                lastFunctionsOutputs,
                itemContext,
                controlCallerId,
                entryVars,
                appProcessId,
                apiBaseInputs,
                isDevelopment: processor.root.isInDevelopment,
                currentUser,
            };
            const safeParams = JSON.parse(JSON.stringify(rawParams));
            if (overwriteExecuteOnCloud) {
                return overwriteExecuteOnCloud(safeParams);
            }
            return processor.root.cloud.executeAppProcessCloud(safeParams);
        })
            .then((data) => {
            if (data) {
                const executeCallback = () => {
                    if (data.callbackKey) {
                        executeProcesses(functionId, callbacks[data.callbackKey], data.returnData);
                    }
                };
                if (data.newApiBaseInputs) {
                    setApiBaseInputs(appId, data.newApiBaseInputs)
                        .then(() => {
                        executeCallback();
                    });
                }
                else {
                    executeCallback();
                }
            }
        })
            .catch((error) => {
            if (processor.root.isInDevelopment) {
                processor.root.alert('Error calling cloud', error.message);
            }
            else {
                throw error;
            }
        });
    }
    else {
        const functionsFromAppProcessCallbacksCallbacks = (0, appProcessLauncher_1.buildFunctionCallerFromCallbacks)(functionId, callbacks, processor, lastFunctionsOutputs, itemContext, controlCallerId);
        (0, appProcessLauncher_1.executeAppProcess)(functionDefinitions)({
            functionsFromAppProcessCallbacksCallbacks,
            processor,
            entryVars,
            appProcessId,
            itemContext,
            eventOutputs,
        });
    }
};
exports.default = appProcessBuilder;
